export class SelectItemModel {
    id: number;
    itemName: string;
    abreviation?: string;
    countryId?: number;
}
